<div class="container">
    <div *ngIf="isLoading" class="row center">
       <div class="spinner-border text-danger" role="status">
          <span class="sr-only">Loading...</span>
       </div>
    </div>
    <div *ngIf="!isLoading" class="row">
       <div class="col-lg-12 col-md-12 col-xs-12">
          <div class="col-md-9 col-xs-9 mgb-10">
             <h2>Soccer-Tennis List</h2>
          </div>
          <div class="col-md-12 col-xs-12">
             <div class="table-responsive">
                <table class="table table-bordered table-striped">
                   <thead>
                      <tr>
                         <th class="center pd1p">#</th>
                         <th>Event ID</th>
                         <th>Event Name</th>
                         <th>Market ID</th>
                         <th>Sport Name</th>
                         <th>Open Date</th>
                      </tr>
                   </thead>
                   <tbody>
                      <tr *ngFor="let data of matchList; let i = index">
                         <td class="center pd1p">{{ i+1 }}</td>
                         <td>{{ data.eventId }}</td>
                         <td>{{ data.eventName }}</td>
                         <td>{{ data.marketId }}</td>
                         <td><span class="badge badgeback">{{ data.sportName }}</span></td>
                         <td>{{ data.openDate }}</td>
                      </tr>
                   </tbody>
                </table>
             </div>
          </div>
       </div>
    </div>
 </div>